import { useGetDealerApprovalByIdQuery, useApproveDealerApprovalMutation, useRejectDealerApprovalMutation, useReturnDealerApprovalMutation } from '../../../../api/endpoints/dealerApproval';
import { useLanguage } from '../../../../contexts/LanguageContext';
import { usePermissions } from '../../../../hooks/usePermissions';
import { toastService } from '../../../../utils/toastService';
import { ApprovalStatus } from '../../../../utils/dealerApprovalEnums';

const useDealerApprovalDetail = (id) => {
    const { th, getCurrentLanguageId } = useLanguage();
    const languageId = getCurrentLanguageId();
    const { hasRole, hasAdminRole } = usePermissions();

    const { data: detail, isLoading, isError, refetch } = useGetDealerApprovalByIdQuery({ id, languageId }, { skip: !id });

    const [approve, { isLoading: isApproving }] = useApproveDealerApprovalMutation();
    const [reject, { isLoading: isRejecting }] = useRejectDealerApprovalMutation();
    const [ret, { isLoading: isReturning }] = useReturnDealerApprovalMutation();

    // Adım aksiyonu görünürlüğü: mevcut adımın rolü kullanıcıda varsa veya Admin ise.
    // Ayrıca talep Pending olmalı. Son yetki kararı backend'dedir.
    const canAct = Boolean(detail && detail.status === ApprovalStatus.PENDING) && (hasAdminRole() || hasRole(detail?.steps?.find((s) => s.stepOrder === detail.currentStepOrder)?.role));

    const doApprove = async (note) => {
        try {
            await approve({ approvalId: Number(id), note, languageId }).unwrap();
            toastService.success(th('dealerApproval.success.approve'));
            refetch();
            return true;
        } catch {
            // Hata mesajı global baseQueryWithReauth tarafından gösteriliyor.
            return false;
        }
    };

    const doReject = async (reason) => {
        try {
            await reject({ approvalId: Number(id), reason, languageId }).unwrap();
            toastService.success(th('dealerApproval.success.reject'));
            refetch();
            return true;
        } catch {
            // Hata mesajı global baseQueryWithReauth tarafından gösteriliyor.
            return false;
        }
    };

    const doReturn = async (note) => {
        try {
            await ret({ approvalId: Number(id), note, languageId }).unwrap();
            toastService.success(th('dealerApproval.success.return'));
            refetch();
            return true;
        } catch {
            // Hata mesajı global baseQueryWithReauth tarafından gösteriliyor.
            return false;
        }
    };

    return {
        detail,
        isLoading,
        isError,
        refetch,
        canAct,
        isBusy: isApproving || isRejecting || isReturning,
        doApprove,
        doReject,
        doReturn
    };
};

export default useDealerApprovalDetail;
